import React, { useState, useEffect } from 'react';
import { Layout, Carousel, Card, Typography, Tag, Button, Row, Col, Divider } from 'antd';
import { UserOutlined, CalendarOutlined } from '@ant-design/icons';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import './index.css';

const { Title, Text } = Typography;
const { Content } = Layout;

const Home = () => {
  const [articles, setArticles] = useState([]);
  const [featuredArticles, setFeaturedArticles] = useState([]);

  useEffect(() => {
    const storedArticles = JSON.parse(localStorage.getItem('articles')) || [];
    setArticles(storedArticles);

    const topArticles = storedArticles.slice(0, 3);
    setFeaturedArticles(topArticles);
  }, []);

  const carouselItems = [
    {
      id: 1,
      title: '欢迎来到我的博客',
      description: '发现更多有趣的技术文章',
      image: 'https://via.placeholder.com/1200x400/40a9ff/ffffff?text=Welcome+to+My+Blog',
      link: '#'
    },
    {
      id: 2,
      title: '.........',
      description: '...........',
      image: 'https://via.placeholder.com/1200x400/1890ff/ffffff?text=React+Features',
      link: '#'
    },
    {
      id: 3,
      title: '...............',
      description: '.............',
      image: 'https://via.placeholder.com/1200x400/722ed1/ffffff?text=Ant+Design+Guide',
      link: '#'
    }
  ];

  return (
    <Layout className="home-layout">
      <AppHeader />
      <Content className="home-content">
        <div className="carousel-container">
          <Carousel autoplay className="home-carousel">
            {carouselItems.map((item) => (
              <div key={item.id} className="carousel-item">
                <div 
                  className="carousel-image" 
                  style={{ 
                    backgroundImage: `url(${item.image})`,
                    height: '400px',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                >
                  <div className="carousel-overlay">
                    <div className="carousel-content">
                      <Title level={2} style={{ color: 'white' }}>{item.title}</Title>
                      <Text style={{ color: 'white', fontSize: '18px' }}>{item.description}</Text>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        {featuredArticles.length > 0 && (
          <div className="featured-section">
            <Title level={2} className="section-title">精选文章</Title>
            <Row gutter={[24, 24]}>
              {featuredArticles.map((article) => (
                <Col xs={24} sm={24} md={12} lg={8} key={article.id}>
                  <Card 
                    hoverable 
                    className="featured-card"
                    cover={
                      <div 
                        className="article-cover" 
                        style={{ 
                          backgroundImage: `url(https://via.placeholder.com/400x200/1890ff/ffffff?text=${encodeURIComponent(article.title)})`,
                          height: '200px',
                          backgroundSize: 'cover',
                          backgroundPosition: 'center'
                        }}
                      />
                    }
                  >
                    <Card.Meta
                      title={<a href={`/article/${article.id}`}>{article.title}</a>}
                      description={
                        <div>
                          <div className="article-meta">
                            <Text type="secondary">
                              <CalendarOutlined /> {article.date}
                            </Text>
                            <Text type="secondary" style={{ marginLeft: '16px' }}>
                              <UserOutlined /> {article.author || '匿名'}
                            </Text>
                          </div>
                          <div className="article-tags" style={{ marginTop: '8px' }}>
                            {article.tags && article.tags.map((tag, index) => (
                              <Tag key={index} color="blue">{tag}</Tag>
                            ))}
                          </div>
                        </div>
                      }
                    />
                    <div className="article-excerpt">
                      <Text type="secondary">{article.abstract}</Text>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        )}

        <Divider />

        <div className="latest-articles-section">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
            <Title level={2} className="section-title">最新文章</Title>
            <Button type="link" href="/archive">查看全部</Button>
          </div>
          
          <div className="articles-list">
            {articles.length > 0 ? (
              articles.slice(0, 6).map((article) => (
                <Card 
                  key={article.id} 
                  className="article-card"
                  hoverable
                >
                  <div className="article-content">
                    <div className="article-text">
                      <a href={`/article/${article.id}`} className="article-title">
                        <Title level={4} style={{ margin: 0 }}>{article.title}</Title>
                      </a>
                      <div className="article-meta" style={{ margin: '12px 0' }}>
                        <Text type="secondary">
                          <CalendarOutlined /> {article.date}
                        </Text>
                        <Text type="secondary" style={{ marginLeft: '16px' }}>
                          <UserOutlined /> {article.author || '匿名'}
                        </Text>
                        <div className="article-tags" style={{ marginTop: '8px' }}>
                          {article.tags && article.tags.map((tag, index) => (
                            <Tag key={index} color="blue" style={{ margin: '2px' }}>{tag}</Tag>
                          ))}
                        </div>
                      </div>
                      <Text type="secondary">{article.abstract}</Text>
                    </div>
                    <div 
                      className="article-image" 
                      style={{ 
                        width: '150px',
                        height: '100px',
                        backgroundImage: `url(https://via.placeholder.com/150x100/1890ff/ffffff?text=${encodeURIComponent(article.title)})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: '4px'
                      }}
                    />
                  </div>
                </Card>
              ))
            ) : (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <Text>暂无文章</Text>
              </div>
            )}
          </div>
        </div>
      </Content>
      <AppFooter />
    </Layout>
  );
};

export default Home;